import { Box } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleX } from '@fortawesome/pro-solid-svg-icons/faCircleX';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { useQuizHotSpotContext } from '../../../../context/QuizHotSpotContext';

export enum cursorType {
  default,
  correct,
  incorrect,
}

type cursorStyle = {
  icon: IconDefinition;
  color: string;
  fontSize: string;
  width: string;
};
/**
 *Get style from current state.
 */
export const getCursor = (value: cursorType): cursorStyle => {
  switch (value) {
    case cursorType.correct:
      return {
        color: 'positive',
        icon: faCircleCheck,
        fontSize: '20px',
        width: '24px',
      };
    case cursorType.incorrect:
      return {
        color: 'negative',
        icon: faCircleX,
        fontSize: '20px',
        width: '24px',
      };
    default:
      return {
        color: 'primary',
        icon: faCircle,
        fontSize: '10px',
        width: '12px',
      };
  }
};

/**
 *Cursor for HotSpot component.
 */
const HotSpotCursor = ({ cursor }: { cursor: cursorType }) => {
  const { position } = useQuizHotSpotContext();

  return (
    <Box
      sx={{
        touchAction: 'none',
        display: 'flex',
        width: getCursor(cursor).width,
        height: getCursor(cursor).width,
        position: 'absolute',
        left: position.x - 8, //top corner of the mouse
        top: position.y - 12, //top corner of the mouse
        backgroundColor: 'white',
        color: getCursor(cursor).color,
        border: '7px solid white',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Icon
        icon={getCursor(cursor).icon}
        fontSize={getCursor(cursor).fontSize}
      />
    </Box>
  );
};

export default HotSpotCursor;
